import classNames from 'classnames'
import React from 'react'
import { ValueLocked } from 'src/components/framework/icons/value-locked'
import { Column, Grid } from 'src/components/framework/ui'
import { ScoreHeader } from 'src/components/page/ratios/score-header'
import * as styles from 'src/components/page/ratios/scores/z-score/z-score.module.scss'

export const ZScore: React.FC = () => {
  return (
    <>
      <ScoreHeader
        title={'Bankruptcy Score'}
        score={'Z-Score'}
        id={'altman-z1-score-39'}
      />
      <div className={classNames(styles.zScoreGraph__bar, 'stk-space-out-t-2')}>
        <span className={styles.zScoreGraph__icon}>
          <ValueLocked />
        </span>
      </div>
      <div className={'stk-space-out-t-1 stk-text-small'}>
        <Grid>
          <Column size={6}>
            <Grid>
              <Column>Distress</Column>
              <Column>Cautious</Column>
            </Grid>
          </Column>
          <Column size={6} className={'stk-text-align-c'}>
            Safe
          </Column>
        </Grid>
      </div>
    </>
  )
}
